import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import type { Customer } from 'src/interfaces/customer'
import {
  isCustomerOnboardedAsMasterContractor,
  shouldShowMasterContractorValue,
} from 'src/utils/customerList'
import { semanticColors } from 'src/constants/semanticTokens'

interface Props {
  customer: Customer
}

/** Only meaningful for master contractors — renders a dash otherwise. */
const CustomerOnboardingChipComponent = ({ customer }: Props) => {
  if (!shouldShowMasterContractorValue(customer)) {
    return <span css={tw`text-shades-400`}>—</span>
  }

  if (isCustomerOnboardedAsMasterContractor(customer)) {
    return (
      <Chip
        text="Onboarded"
        className={{ backgroundColor: semanticColors.feedback.successBg }}
        textClassName={{ color: semanticColors.feedback.successFg }}
      />
    )
  }

  return (
    <Chip
      text="Incomplete"
      className={{ backgroundColor: semanticColors.feedback.warningBg }}
      textClassName={{ color: semanticColors.feedback.warningFg }}
    />
  )
}

export const CustomerOnboardingChip = memo(CustomerOnboardingChipComponent)
